const ActiveTabsIndexes = {
  TOPICS: 0,
  PEOPLE: 1,
  SPONSORS: 2,
};

export default ActiveTabsIndexes;
